import * as Yup from 'yup';

export const getCustomIncidentTypeSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('Category Name is required'),
  });
};

export const getDeleteCustomIncidentTypeSchema = (name: string) => {
  return Yup.object().shape({
    name: Yup.string()
      .oneOf(
        [`${name.trim().replace(/\s+/g, ' ')}`],
        `You must type "${name.trim().replace(/\s+/g, ' ')}" exactly`,
      )
      .required('Name is required'),
  });
};
